import styled from 'styled-components';

const MenuLabel = styled.div`
  color: rgba(255, 255, 255, 0.5);
  font-size: 15px;
  margin: 21px 26px 2px 26px;
`;

export default MenuLabel;
